<div class="dialog-title mat-tab-label-active text-muted px-3">
  Set New Alert
  <button mat-icon-button aria-label="close dialog" mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
</div>
<div id="dark">
  <div>
    <div class="d-flex text-color-theme justify-content-between p-3">
      <div>
        {{data.nameEn}}
      </div>
      <div>
        <strong>{{data.reuters}}</strong>
      </div>
    </div>
    <div>
      <table class="table text-center">
        <thead>
          <tr style="padding-inline-end: 10px;">
            <th>Parameter</th>
            <th>Criteria</th>
            <th>Value</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr class="no-hover">
            <td>
              <select [(ngModel)]="tempCondition.PropertyName" name="PropertyName" class="form-control form-control-sm">
                <option value='Best Bid'>Best Bid</option>
                <option value='Best Offer'>Best Offer</option>
                <option value='Last'>Last</option>
                <option value='Last Qty'>Last Qty</option>
                <option value='Bid Qty'>Bid Qty</option>
                <option value='Offer Qty'>Offer Qty</option>
                <option value='Volume'>Volume</option>
                <option value='Change'>Change</option>
                <option value='Change %'>Change %</option>
              </select>
            </td>
            <td>
              <select [(ngModel)]="tempCondition.Condition" name="Condition" class="form-control form-control-sm">
                <option value=">">Greater Than</option>
                <option value=">=">Greater Than or Equal</option>
                <option value="<">Less Than</option>
                <option value="<=">Less Than or Equal</option>
                <option value="=">Equal</option>
              </select>
            </td>
            <td>
              <input [(ngModel)]="tempCondition.PropertyValue" name="PropertyValue" class="form-control form-control-sm">
            </td>
            <td style="padding: 0px !important;">
              <div class="d-flex" style="padding: 0px !important; vertical-align: middle !important;">
                <button type="submit" (click)="addAlert()" mat-icon-button color="primary">
                  <mat-icon>add_circle</mat-icon>
                </button>
              </div>
            </td>
          </tr>
          <tr *ngFor="let alert of newAlert.Conditions;let i = index">
            <td class="text-center">{{alert.PropertyName}}</td>
            <td class="text-center">{{alert.Condition}}</td>
            <td class="text-center">{{alert.PropertyValue}}</td>
            <td style="padding: 0px !important;">
              <div class="d-flex" style="padding: 0px !important; vertical-align: middle !important;">
                <button (click)="removeAlert(i)" mat-icon-button color="warn">
                  <mat-icon>delete_circle</mat-icon>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="row m-1">
    <!-- <div class="col-md-4">
      <label class="text-color-theme required">Alert Condition</label>
      <select class="form-control" id="securityOne" [(ngModel)]="newAlert.condition" name="condition">
        <option value="all">Match All</option>
        <option value="any">Match Any</option>
      </select>
    </div> -->
    <div class="col-md-4">
      <label class="text-color-theme required">Expiration Type</label>
      <select class="form-control" id="securityOne" [(ngModel)]="newAlert.ExpirationType" name="condition">
        <option value=1>1 Day</option>
        <option value=2>1 Week</option>
        <option value=3>1 Month</option>
        <option value=4>To Date</option>
      </select>
      <!-- <label class="text-color-theme required" *ngIf="requestObject.ExpirationType == 4">Select Date</label> -->
      <div *ngIf="newAlert.ExpirationType == 4" class="mt-1">
        <input placeholder="Select Date" (focus)="picker.open()" class="form-control" #date id="date" matInput name="withdrawDate" [(ngModel)]="newAlert.ExpirationDate" [matDatepicker]="picker">
        <!-- <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle> -->
        <mat-datepicker #picker></mat-datepicker>
      </div>

      <!-- <label class="required">Expiration</label>
      <select id="securityOne" [(ngModel)]="requestObject.expirationDate" name="condition" class="custom-select">
        <option value="all">Match All</option>
        <option value="any">Match Any</option>
      </select> -->
    </div>
    <div class="col-md-4">
      <!-- <label class="text-color-theme required">Notifications</label>
      <select class="selectpicker" id="securityOne" multiple [(ngModel)]="requestObject.notification" name="notifications">
        <option value="all">Web</option>
        <option value="any">Mobile</option>
        <option value="any">Email</option>
        <option value="any">Sms</option>
      </select> -->
      <label class="text-color-theme required">Notifications</label>
      <div>
        <mat-select class="form-control" [(ngModel)]="newAlert.NotificationType" multiple>
          <mat-option *ngFor="let item of notificationTypes" [value]="item.value">{{item.name}}</mat-option>
        </mat-select>
      </div>
    </div>
  </div>
  <div class="d-flex justify-content-end p-3 mt10">
    <div class="mx-1">
      <button mat-flat-button color="primary" (click)="alertManager()">Alert Manager</button>
    </div>
    <div class="mx-1">
      <button mat-flat-button (click)="createAlert()" style="background: rgb(125, 219, 125);">Set Alert</button>
    </div>
  </div>
</div>
